import React from 'react';
import './Features.scss';

interface Feature {
  title: string;
  summary: string;
  backDescription: string;
  image: string;
}

const features: Feature[] = [
  {
    title: 'Punto Digital',
    summary: 'Tus clientes, a un clic',
    backDescription:
      'Tu restaurante en un solo enlace: reseñas, reservas, menú digital y programa de lealtad — todo accesible al instante.',
    image: 'punto-digital.png',
  },
  {
    title: 'Control de Stock',
    summary: 'Inventario al día, siempre',
    backDescription:
      'Controla tu inventario en tiempo real, recibe alertas de stock bajo y automatiza tus pedidos para que nunca te falten ingredientes.',
    image: 'stock_control_V3.png',
  },
  {
    title: 'Reservas Online',
    summary: 'Adiós a los cuadernos',
    backDescription:
      'Tus clientes reservan en línea con confirmaciones automáticas, gestión de mesas inteligente y cero overbooking.',
    image: 'reservations.png',
  },
  {
    title: 'Cupones & Descuentos',
    summary: 'Promociones al instante',
    backDescription:
      'Crea promociones irresistibles: códigos QR, segmentación de ofertas y métricas de redención en tiempo real.',
    image: 'coupons_V2.jpg',
  },
  {
    title: 'Gestión de Personal',
    summary: 'Equipo alineado y motivado',
    backDescription:
      'Controla horarios, mide desempeño individual y automatiza evaluaciones para que tu equipo rinda al máximo.',
    image: 'staff-managementV2.jpg',
  },
];

const Features: React.FC = () => (
  <div className="features-grid">
    {features.map((f, i) => (
      <div key={i} className="flip-card">
        <div className="flip-card-inner">
          <div className="flip-card-front">
            <div className="card-image">
              <img
                src={`${process.env.PUBLIC_URL}/web_page_images/${f.image}`}
                alt={f.title}
                className={
                  f.title === 'Cupones & Descuentos'
                    ? 'feature-image feature-image--coupons'
                    : f.title === 'Punto Digital' || f.title === 'Reservas Online'
                    ? 'feature-image feature-image--small'
                    : 'feature-image'
                }
              />
            </div>
            <div className="card-title">{f.title}</div>
            <div className="card-summary">{f.summary}</div>
          </div>
          <div className="flip-card-back">
            <h3>{f.title}</h3>
            <p>{f.backDescription}</p>
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default Features;
